import { type ReactNode, createContext, useContext } from "react";
import type {
  ICarouselEditorData,
  ICarouselSets,
  ICarouselSettings,
} from "../types";
import { ensureCarouselComboSettings } from "../utils";

export interface ICarouselCtx {
  comboId: string;
  comboLayers?: Record<string, Record<string, any>> | undefined;
  isSideBySide: boolean;
  isFullScreen: boolean;
  isEditor: boolean;
  editorData?: ICarouselEditorData;
  comboSettings: ICarouselSettings;
  sets: ICarouselSets;
  handleSwapNext: () => void;
  handleSwapPrev: () => void;
}

const initState: ICarouselCtx = {
  comboId: "",
  isSideBySide: true,
  isFullScreen: false,
  isEditor: false,
  sets: [],
  handleSwapNext: () => {},
  handleSwapPrev: () => {},
  comboSettings: ensureCarouselComboSettings(),
};

export const CarouselCtx = createContext<ICarouselCtx>(initState);

interface IProps {
  children: ReactNode;
  ctxState: ICarouselCtx;
}

export const CarouselCtxProvider = ({ children, ctxState }: IProps) => {
  return (
    <CarouselCtx.Provider value={ctxState}>{children}</CarouselCtx.Provider>
  );
};

export const useCarouselCtx = () => {
  const ctx = useContext(CarouselCtx);
  if (!ctx) throw Error("useCarouselCtx: CarouselCtx is not defined!");
  return ctx;
};
